import { observeElement } from '@uvocore-front/utils';
import TestimonialsSlider from './TestimonialsSlider';
import { formatDate } from '../../utils';

const template = (i) => `<div class="glide__slide">
  <div class="testimonials__item">
    <div class="testimonials__item__body">"${i.body}"</div>
    <div class="testimonials__item__footer">
      <div class="testimonials__item__discipline">${i.orderDiscipline}</div>
      <div class="testimonials__item__id">ID ${i.customerId}XXX</div>
      <div class="testimonials__item__date">${formatDate(i.createdAt)}</div>
    </div>
  </div>
</div>`;

observeElement({
  element: '[data-testimonials-widget-js]',
  marginValue: 800,
  callback: () => {
    fetch('/assets/testimonials/list.json?siteId=199&limit=10&minBodyLength=60&maxBodyLength=90')
      .then((response) => response.json())
      .then((responseData) => {
        const { testimonials } = responseData.data;
        const testimonialsNode = document.querySelector('.testimonials');
        testimonialsNode.removeChild(testimonialsNode.querySelector('.Loader'));
        const tmNodes = testimonials.map((tm) => template(tm)).join('');
        document
          .querySelector('.testimonials__container')
          .insertAdjacentHTML('afterbegin', tmNodes);
        TestimonialsSlider();
      });
  },
});
